// Custom events have been added to the theme to make adding
// custom functionality easier. The below events have been
// exposed as well as the associated data for each event.
// To enable this functionality update the 'useCustomEvents' variable in
// the theme.liquid file to 'true'.

// This event fires whenever an item has been added to the cart.
// This event is exposed when the ajax cart is enabled.
// The product object is passed within the detail object.
document.addEventListener("cart:item-added", function (evt) {
  console.log("Item added to the cart");
  console.log(evt.detail.product);
});

// This event fires whenever the cart is updated.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("cart:updated", function (evt) {
  console.log("Cart updated");
  console.log(evt.detail.cart);
});

// This event fires whenever there is an error when adding an item to the cart.
// This error is typically due to a product not having sufficient stock.
// The error message is passed within the detail object.
document.addEventListener("cart:error", function (evt) {
  console.log("Cart error");
  console.log(evt.detail.errorMessage);
});

// This event fires whenever the quick cart is opened.
// This event is exposed when the ajax cart is enabled.
// The cart object is passed within the detail object.
document.addEventListener("quick-cart:open", function (evt) {
  console.log("Quick cart opened");
  console.log(evt.detail.cart);
});

// This event fires whenever the quick cart is closed.
document.addEventListener("quick-cart:close", function () {
  console.log("Quick cart closed");
});

// This event fires whenever a variant product is selected.
document.addEventListener("product:variant-change", function (evt) {
  console.log("Product variant changed");
  console.log(evt.detail.variant);
});

// This event fires whenever a product quantity is updated.
document.addEventListener("product:quantity-update", function (evt) {
  console.log("Product quantity updated");
  console.log(evt.detail.quantity, evt.detail.variant);
});

// This event fires whenever quickview modal is opened.
document.addEventListener("quickview:loaded", function () {
  console.log("Quickview loaded");
});


/* ------------------------------------------------------------
   Johnnie Team - Color-aware Pairs Well With
------------------------------------------------------------- */

(function () {

  function normalizeColor(value) {
    return String(value || "")
      .trim()
      .toLowerCase()
      .replace(/\s+/g, " ");
  }


  function getVariantColor(variant, position) {
    if (!variant || !position) return "";

    if (position === 1) return variant.option1 || "";
    if (position === 2) return variant.option2 || "";
    if (position === 3) return variant.option3 || "";

    return "";
  }


  function updateCardImage(card, imageUrl) {
    if (!imageUrl) return;

    const image = card.querySelector("img");

    if (!image) return;

    image.src = imageUrl;
    image.srcset = imageUrl;

    if (image.dataset.src !== undefined) {
      image.dataset.src = imageUrl;
    }

    if (image.dataset.srcset !== undefined) {
      image.dataset.srcset = imageUrl;
    }

    const picture = image.closest("picture");

    if (picture) {
      picture
        .querySelectorAll("source")
        .forEach(function (source) {
          source.srcset = imageUrl;

          if (source.dataset.srcset !== undefined) {
            source.dataset.srcset = imageUrl;
          }
        });
    }
  }


  function updateCardLinks(
    card,
    productUrl,
    variantId
  ) {

    if (!productUrl || !variantId) return;

    const separator =
      productUrl.includes("?")
        ? "&"
        : "?";

    const variantUrl =
      productUrl +
      separator +
      "variant=" +
      encodeURIComponent(variantId);

    card
      .querySelectorAll(
        'a[href*="/products/"]'
      )
      .forEach(function (link) {
        link.href = variantUrl;
      });
  }


  /*
   * Update displayed recommendation price
   * to exact selected-color variant price.
   */

  function updateCardPrice(
    card,
    formattedPrice,
    formattedCompareAtPrice
  ) {

    if (!formattedPrice) return;

    const priceElement =
      card.querySelector(
        ".product-item__price, " +
        ".product-item__price-wrapper, " +
        "[data-product-item-price]"
      );

    if (!priceElement) return;

    const innerPrice =
      priceElement.querySelector(
        ".price, .sale, .regular-price"
      );

    const target =
      innerPrice || priceElement;

    target.innerHTML = "";


    if (formattedCompareAtPrice) {

      const comparePrice =
        document.createElement("s");

      comparePrice.textContent =
        formattedCompareAtPrice;

      target.appendChild(
        comparePrice
      );

      target.appendChild(
        document.createTextNode(" ")
      );
    }


    const currentPrice =
      document.createElement("span");

    currentPrice.textContent =
      formattedPrice;

    target.appendChild(
      currentPrice
    );
  }


  /*
   * Sync the ADD button to the exact
   * variant currently displayed.
   */

  function updateAddButton(
    card,
    matchingVariant,
    isSoldOut
  ) {

    const addButton =
      card.querySelector(
        "[data-jt-pairs-add]"
      );

    if (!addButton) return;


    const addLabel =
      addButton.querySelector(
        "[data-jt-pairs-add-label]"
      );


    if (!matchingVariant) {

      addButton.removeAttribute(
        "data-add-item-id"
      );

      addButton.disabled = true;

      addButton.setAttribute(
        "aria-disabled",
        "true"
      );

      if (addLabel) {
        addLabel.textContent = "SOLD OUT";
      }

      return;
    }


    /*
     * This is the important part:
     * Stiletto's add button receives the
     * exact variant shown by this card.
     */

    addButton.dataset.addItemId =
      String(
        matchingVariant.id
      );


    const unavailable =
      isSoldOut === true ||
      matchingVariant.available !== true;


    if (unavailable) {

      addButton.disabled = true;

      addButton.setAttribute(
        "aria-disabled",
        "true"
      );

      if (addLabel) {
        addLabel.textContent =
          "SOLD OUT";
      }

    } else {

      addButton.disabled = false;

      addButton.removeAttribute(
        "aria-disabled"
      );

      if (addLabel) {
        addLabel.textContent =
          "ADD";
      }
    }
  }


  function removeSoldOutLabel(card) {

    const oldLabel =
      card.querySelector(
        "[data-jt-complete-look-sold-out]"
      );

    if (oldLabel) {
      oldLabel.remove();
    }


    const image =
      card.querySelector("img");

    if (image) {
      image.style.filter = "";
      image.style.opacity = "";
    }


    const imageWrapper =
      card.querySelector(
        "[data-jt-sold-out-image-wrapper]"
      );

    if (imageWrapper) {

      imageWrapper.removeAttribute(
        "data-jt-sold-out-image-wrapper"
      );

      imageWrapper.style.position = "";
    }
  }


  function addSoldOutLabel(card) {

    const image =
      card.querySelector("img");

    if (!image) return;


    image.style.filter =
      "grayscale(45%) brightness(78%)";

    image.style.opacity =
      "0.88";


    const imageWrapper =
      image.closest("a") ||
      image.closest("picture") ||
      image.parentElement;

    if (!imageWrapper) return;


    imageWrapper.setAttribute(
      "data-jt-sold-out-image-wrapper",
      ""
    );

    imageWrapper.style.position =
      "relative";


    const soldOutLabel =
      document.createElement("div");

    soldOutLabel.setAttribute(
      "data-jt-complete-look-sold-out",
      ""
    );

    soldOutLabel.textContent =
      "SOLD OUT";

    soldOutLabel.style.position =
      "absolute";

    soldOutLabel.style.left =
      "10px";

    soldOutLabel.style.bottom =
      "10px";

    soldOutLabel.style.zIndex =
      "5";

    soldOutLabel.style.background =
      "rgba(255, 255, 255, 0.92)";

    soldOutLabel.style.color =
      "#111";

    soldOutLabel.style.padding =
      "6px 9px";

    soldOutLabel.style.fontSize =
      "11px";

    soldOutLabel.style.fontWeight =
      "600";

    soldOutLabel.style.letterSpacing =
      "0.1em";

    soldOutLabel.style.lineHeight =
      "1";

    soldOutLabel.style.whiteSpace =
      "nowrap";

    soldOutLabel.style.pointerEvents =
      "none";


    imageWrapper.appendChild(
      soldOutLabel
    );
  }


  function updateCompleteTheLook(
    selectedVariant
  ) {

    document
      .querySelectorAll(
        '[data-featured-products][data-recommendations-type="custom-product-list"]'
      )
      .forEach(function (container) {


        const mainColorPosition =
          parseInt(
            container.dataset.jtColorPosition,
            10
          ) || 0;


        let selectedColor =
          container.dataset.jtCurrentColor ||
          "";


        if (selectedVariant) {

          selectedColor =
            getVariantColor(
              selectedVariant,
              mainColorPosition
            );
        }


        selectedColor =
          normalizeColor(
            selectedColor
          );


        if (!selectedColor) return;


        container.dataset.jtCurrentColor =
          selectedColor;


        /*
         * -----------------------------------------------
         * PRODUCT COUNT
         *
         * 0 - 719px = 2 products
         * 720px+     = up to 3 products
         * -----------------------------------------------
         */

        const desktopMaxProducts =
          parseInt(
            container.dataset.maxRecommendations,
            10
          ) || 3;


        const maxProducts =
          window.matchMedia(
            "(max-width: 719px)"
          ).matches
            ? Math.min(
                2,
                desktopMaxProducts
              )
            : desktopMaxProducts;


        const cards =
          Array.from(
            container.querySelectorAll(
              "[data-jt-complete-look-item]"
            )
          );


        let productsShown = 0;


        cards.forEach(
          function (card, index) {


            /*
             * Hide every candidate first.
             */

            card.style.display =
              "none";


            /*
             * Reset sold-out state.
             */

            removeSoldOutLabel(
              card
            );


            /*
             * Stop once the maximum number
             * of products is displayed.
             */

            if (
              productsShown >=
              maxProducts
            ) {
              return;
            }


            const colorPosition =
              parseInt(
                card.dataset.jtColorPosition,
                10
              ) || 0;


            if (!colorPosition) {
              return;
            }


            const variantsScript =
              card.querySelector(
                "[data-jt-complete-look-variants]"
              );


            if (!variantsScript) {
              return;
            }


            let variants = [];


            try {

              variants =
                JSON.parse(
                  variantsScript.textContent
                );

            } catch (error) {

              console.error(
                "Johnnie Team Pairs Well With: unable to read variants",
                error
              );

              return;
            }


            /*
             * Find every variant belonging
             * to currently selected color.
             */

            const sameColorVariants =
              variants.filter(
                function (variant) {

                  const variantColor =
                    normalizeColor(
                      getVariantColor(
                        variant,
                        colorPosition
                      )
                    );

                  return (
                    variantColor ===
                    selectedColor
                  );
                }
              );


            /*
             * Product does not exist
             * in selected color.
             */

            if (
              !sameColorVariants.length
            ) {
              return;
            }


            let matchingVariant =
              null;

            let isSoldOut =
              false;


            /*
             * -----------------------------------------------
             * PRODUCT #1
             *
             * Matching product.
             *
             * Always show when selected color exists.
             * If sold out, still display it.
             * -----------------------------------------------
             */

            if (index === 0) {

              matchingVariant =
                sameColorVariants.find(
                  function (variant) {
                    return (
                      variant.available ===
                      true
                    );
                  }
                ) ||
                sameColorVariants[0];


              isSoldOut =
                !sameColorVariants.some(
                  function (variant) {
                    return (
                      variant.available ===
                      true
                    );
                  }
                );
            }


            /*
             * -----------------------------------------------
             * PRODUCTS #2+
             *
             * Optional recommendations.
             *
             * Must exist in selected color
             * AND be available.
             * -----------------------------------------------
             */

            else {

              matchingVariant =
                sameColorVariants.find(
                  function (variant) {
                    return (
                      variant.available ===
                      true
                    );
                  }
                );


              if (!matchingVariant) {
                return;
              }
            }


            /*
             * Update image.
             */

            updateCardImage(
              card,
              matchingVariant.image
            );


            /*
             * Update product links.
             */

            updateCardLinks(
              card,
              card.dataset.jtProductUrl,
              matchingVariant.id
            );


            /*
             * Sync ADD button to this
             * exact displayed variant.
             */

            updateAddButton(
              card,
              matchingVariant,
              isSoldOut
            );


            /*
             * Update exact variant price.
             */

            updateCardPrice(
              card,
              matchingVariant.price,
              matchingVariant.compare_at_price
            );


            /*
             * Matching product sold out.
             */

            if (isSoldOut) {

              addSoldOutLabel(
                card
              );
            }


            /*
             * Reveal recommendation.
             */

            card.style.display =
              "";


            productsShown++;
          }
        );


        /*
         * Hide entire section only when
         * nothing qualifies.
         */

        const block =
          container.closest(
            ".product__block-featured-products"
          );


        if (block) {

          block.style.display =
            productsShown > 0
              ? ""
              : "none";
        }
      });
  }


  function getCurrentMainVariant() {

    const variantId =
      new URL(
        window.location.href
      ).searchParams.get(
        "variant"
      );


    if (!variantId) {
      return null;
    }


    const productJson =
      document.querySelector(
        'script[id^="ProductJson-"]'
      );


    if (!productJson) {
      return null;
    }


    try {

      const productData =
        JSON.parse(
          productJson.textContent
        );


      const variants =
        Array.isArray(
          productData
        )
          ? productData
          : productData.variants ||
            [];


      return (
        variants.find(
          function (variant) {

            return (
              String(
                variant.id
              ) ===
              String(
                variantId
              )
            );
          }
        ) || null
      );

    } catch (error) {

      console.error(
        "Johnnie Team Pairs Well With: unable to read main product",
        error
      );

      return null;
    }
  }


  function updateFromCurrentVariant() {

    const variant =
      getCurrentMainVariant();


    if (variant) {

      updateCompleteTheLook(
        variant
      );

    } else {

      updateCompleteTheLook();
    }
  }


  /*
   * Initial page load.
   */

  document.addEventListener(
    "DOMContentLoaded",
    function () {
      updateFromCurrentVariant();
    }
  );


  /*
   * Normal Stiletto/theme variant-change event.
   */

  document.addEventListener(
    "product:variant-change",
    function (evt) {

      if (
        !evt.detail ||
        !evt.detail.variant
      ) {
        return;
      }


      updateCompleteTheLook(
        evt.detail.variant
      );
    }
  );


  /*
   * Watch Shopify/theme URL changes
   * when swatches change.
   */

  if (
    !window.jtCompleteLookHistoryHooked
  ) {

    window.jtCompleteLookHistoryHooked =
      true;


    [
      "pushState",
      "replaceState"
    ].forEach(
      function (methodName) {

        const originalMethod =
          history[
            methodName
          ];


        history[
          methodName
        ] =
          function () {

            const result =
              originalMethod.apply(
                this,
                arguments
              );


            setTimeout(
              function () {
                updateFromCurrentVariant();
              },
              50
            );


            return result;
          };
      }
    );


    window.addEventListener(
      "popstate",
      function () {

        setTimeout(
          function () {
            updateFromCurrentVariant();
          },
          50
        );
      }
    );
  }


  /*
   * Extra fallback for variant selectors.
   */

  document.addEventListener(
    "change",
    function () {

      setTimeout(
        function () {
          updateFromCurrentVariant();
        },
        100
      );
    },
    true
  );


  /*
   * Recalculate when crossing
   * mobile / desktop breakpoint.
   */

  let jtCompleteLookResizeTimer;


  window.addEventListener(
    "resize",
    function () {

      clearTimeout(
        jtCompleteLookResizeTimer
      );


      jtCompleteLookResizeTimer =
        setTimeout(
          function () {
            updateFromCurrentVariant();
          },
          100
        );
    }
  );

/* ------------------------------------------------------------
   Pairs Well With - ADD TO CART
------------------------------------------------------------- */

document.addEventListener(
  "click",
  async function (event) {

    const button =
      event.target.closest(
        "[data-jt-pairs-add]"
      );

    if (!button) return;

    event.preventDefault();
    event.stopPropagation();


    if (button.disabled) {
      return;
    }


    const variantId =
      button.dataset.addItemId;


    if (!variantId) {

      console.error(
        "Johnnie Team Pairs Well With: no variant ID found."
      );

      return;
    }


    const label =
      button.querySelector(
        "[data-jt-pairs-add-label]"
      );


    const originalLabel =
      label
        ? label.textContent
        : "ADD";


    button.disabled = true;


    if (label) {
      label.textContent = "•••";
    }


    try {

      const root =
        window.Shopify &&
        window.Shopify.routes &&
        window.Shopify.routes.root
          ? window.Shopify.routes.root
          : "/";


      const response =
        await fetch(
          root + "cart/add.js",
          {
            method: "POST",

            credentials:
              "same-origin",

            headers: {
              "Content-Type":
                "application/json",

              "Accept":
                "application/json"
            },

            body: JSON.stringify({
              items: [
                {
                  id:
                    Number(
                      variantId
                    ),

                  quantity: 1
                }
              ]
            })
          }
        );


      const result =
        await response.json();


      if (!response.ok) {

        throw new Error(
          result.description ||
          result.message ||
          "Could not add item to cart."
        );
      }


      /*
       * Refresh Stiletto quick cart
       * and header cart count.
       */

      document.dispatchEvent(
        new CustomEvent(
          "apps:product-added-to-cart"
        )
      );


      /*
       * Open the Stiletto quick cart.
       */

      setTimeout(
        function () {

          const cartTrigger =
            document.querySelector(
              "[data-js-cart-icon]"
            );


          if (cartTrigger) {

            cartTrigger.click();

          } else {

            console.warn(
              "Johnnie Team Pairs Well With: cart trigger not found."
            );
          }

        },
        300
      );


      /*
       * Return button to ADD.
       */

      setTimeout(
        function () {

          button.disabled = false;

          if (label) {
            label.textContent =
              originalLabel;
          }

        },
        700
      );


    } catch (error) {

      console.error(
        "Johnnie Team Pairs Well With: add to cart failed",
        error
      );


      button.disabled = false;


      if (label) {
        label.textContent = "ADD";
      }


      alert(
        error &&
        error.message
          ? error.message
          : "Could not add this item. Please try again."
      );
    }
  }
);
})();

/* ------------------------------------------------------------
   Johnnie Team - Quick Cart Complete the Set
------------------------------------------------------------- */

(function () {

  if (window.JTCompleteSetGlobalBound) return;

  window.JTCompleteSetGlobalBound = true;


  /* ----------------------------------------------------------
     SIZE CHANGE
  ---------------------------------------------------------- */

  document.addEventListener(
    "change",
    function (event) {

      const select =
        event.target.closest(
          "[data-jt-complete-set-select]"
        );

      if (!select) return;


      const item =
        select.closest(
          ".jt-cart-complete-look__item"
        );

      if (!item) return;


      const button =
        item.querySelector(
          "[data-jt-complete-set-button]"
        );

      const price =
        item.querySelector(
          ".jt-cart-complete-look__price"
        );


      if (button) {

        button.setAttribute(
          "data-jt-variant-id",
          select.value
        );

      }


      const selectedOption =
        select.options[
          select.selectedIndex
        ];


      if (
        price &&
        selectedOption &&
        selectedOption.dataset.price
      ) {

        price.textContent =
          selectedOption.dataset.price;

      }

    }
  );


  /* ----------------------------------------------------------
     ADD PRODUCT
  ---------------------------------------------------------- */

  document.addEventListener(
    "click",
    async function (event) {

      const button =
        event.target.closest(
          "[data-jt-complete-set-button]"
        );

      if (!button) return;


      event.preventDefault();
      event.stopPropagation();


      if (button.disabled) return;


      const variantId =
        button.getAttribute(
          "data-jt-variant-id"
        );


      if (!variantId) {

        console.error(
          "JT Complete Set: Missing variant ID."
        );

        return;

      }


      const symbol =
        button.querySelector(
          ".jt-cart-complete-look__add-symbol"
        );


      button.disabled = true;


      if (symbol) {
        symbol.textContent = "…";
      }


      try {

        const root =
          window.Shopify &&
          Shopify.routes &&
          Shopify.routes.root
            ? Shopify.routes.root
            : "/";


        /* ----------------------------------------------------
           1. ADD PRODUCT

           Keep this request simple.
           Do not make cart/add responsible for rendering
           the quick cart as well.
        ----------------------------------------------------- */

        const addResponse =
          await fetch(
            root + "cart/add.js",
            {
              method: "POST",

              headers: {
                "Content-Type":
                  "application/json",

                "Accept":
                  "application/json"
              },

              body: JSON.stringify({
                items: [
                  {
                    id: Number(
                      variantId
                    ),

                    quantity: 1
                  }
                ]
              })
            }
          );


        const addResult =
          await addResponse.json();


        if (!addResponse.ok) {

          throw new Error(
            addResult &&
            addResult.description
              ? addResult.description
              : "Could not add product to cart."
          );

        }


        /* ----------------------------------------------------
           2. FIND CURRENT QUICK CART

           Find it from the clicked button itself so we always
           refresh the exact drawer the customer is using.
        ----------------------------------------------------- */

        const quickCart =
          button.closest(
            ".quick-cart"
          );


        if (!quickCart) {

          throw new Error(
            "Product was added, but quick cart could not be found."
          );

        }


        const currentSection =
          quickCart.closest(
            ".shopify-section"
          );


        if (
          !currentSection ||
          !currentSection.id
        ) {

          throw new Error(
            "Product was added, but quick cart section could not be found."
          );

        }


        const sectionId =
          currentSection.id.replace(
            /^shopify-section-/,
            ""
          );


        /* ----------------------------------------------------
           3. ASK SHOPIFY TO RENDER JUST QUICK CART

           section_id returns HTML directly.
        ----------------------------------------------------- */

        const renderURL =
          new URL(
            window.location.href
          );


        renderURL.hash = "";

        renderURL.search = "";

        renderURL.searchParams.set(
          "section_id",
          sectionId
        );


        const renderResponse =
          await fetch(
            renderURL.toString(),
            {
              headers: {
                "Accept":
                  "text/html"
              }
            }
          );


        if (!renderResponse.ok) {

          throw new Error(
            "Product was added, but quick cart could not refresh."
          );

        }


        const freshHTML =
          await renderResponse.text();


        if (!freshHTML) {

          throw new Error(
            "Product was added, but Shopify returned an empty quick cart."
          );

        }


        /* ----------------------------------------------------
           4. PARSE UPDATED QUICK CART
        ----------------------------------------------------- */

        const parser =
          new DOMParser();


        const freshDocument =
          parser.parseFromString(
            freshHTML,
            "text/html"
          );


        const freshQuickCart =
          freshDocument.querySelector(
            ".quick-cart"
          );


        if (!freshQuickCart) {

          throw new Error(
            "Product was added, but updated quick cart could not be read."
          );

        }


        const currentContainer =
          quickCart.querySelector(
            ".quick-cart__container"
          );


        const freshContainer =
          freshQuickCart.querySelector(
            ".quick-cart__container"
          );


        if (
          !currentContainer ||
          !freshContainer
        ) {

          throw new Error(
            "Product was added, but updated cart content could not be found."
          );

        }


        /* ----------------------------------------------------
           5. REPLACE ONLY CONTENT

           Do NOT replace:
           - quick-cart wrapper
           - overlay
           - active/open state

           This keeps the drawer open.
        ----------------------------------------------------- */

        currentContainer.innerHTML =
          freshContainer.innerHTML;


        /* ----------------------------------------------------
           6. GET CURRENT CART DATA
        ----------------------------------------------------- */

        const cartResponse =
          await fetch(
            root + "cart.js",
            {
              headers: {
                "Accept":
                  "application/json"
              }
            }
          );


        if (cartResponse.ok) {

          const updatedCart =
            await cartResponse.json();


          /* Global cart counters */

          document
            .querySelectorAll(
              "[data-cart-count], [data-cart-item-count]"
            )
            .forEach(
              function (count) {

                count.textContent =
                  updatedCart.item_count;

              }
            );


          /* Theme/custom event */

          document.dispatchEvent(
            new CustomEvent(
              "cart:item-added",
              {
                detail: {
                  product:
                    addResult
                }
              }
            )
          );


          document.dispatchEvent(
            new CustomEvent(
              "cart:updated",
              {
                detail: {
                  cart:
                    updatedCart
                }
              }
            )
          );

        }

      } catch (error) {

        console.error(
          "JT Complete Set:",
          error
        );


        button.disabled = false;


        if (symbol) {
          symbol.textContent = "+";
        }


        /*
         * If the item was successfully added and only
         * the drawer refresh failed, don't tell the
         * customer the ADD failed.
        */

        if (
          String(
            error.message || ""
          ).includes(
            "Product was added"
          )
        ) {

          console.warn(
            error.message
          );

          return;

        }


        alert(
          error &&
          error.message
            ? error.message
            : "Could not add this item. Please try again."
        );

      }

    }
  );

})();